var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5296 0L0.133789 6V18L10.5296 24L20.9255 18V6L10.5296 0ZM10.5296 0L0.133789 6V18L10.5296 24L20.9255 18V6L10.5296 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6336 19.3123H13.1543L11.384 17.687V16.8538L13.2176 15.1037V12.3331L15.6138 10.7702L18.3431 12.8323L14.6336 19.3123ZM8.50883 14.9376L8.77955 12.3331L7.88387 9.99936H13.1754L12.2999 12.3331L12.5504 14.9376H10.5085H8.50883ZM9.71747 17.687L7.94627 19.3325H6.44579L2.71619 12.8323L5.46659 10.7904L7.88291 12.3322V15.1027L9.71651 16.8528L9.71747 17.687ZM6.42563 5.18784H14.6135L15.5927 9.35424H5.46755L6.42563 5.18784ZM10.5296 0L0.133789 6V18L10.5296 24L20.9255 18V6L10.5296 0Z",
    fill: "#03316C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoCom);
export default __webpack_public_path__ + "static/media/crypto-com.08770e7c68075ac445e98466600cd8fc.svg";
export { ForwardRef as ReactComponent };